import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import styles from "./capabilities.module.css";
import { Button, Section, SectionIntro } from "../../../../COMPONENTS/UI";
import TextReveal from "../../../../COMPONENTS/ANIMATION/TextReveal";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import { capabilities } from "../../../../CONTENT/home";
import { EASE } from "../../../../UTILS/ANIMATION/motionVariants";

const Block = ({ item, index }) => {
  const reduce = useReducedMotion();
  const flip = index % 2 === 1;
  return (
    <article className={`${styles.block} ${flip ? styles.flip : ""}`}>
      <Reveal className={styles.copy}>
        <p className={styles.label}>
          <span className={styles.index}>0{index + 1}</span>
          {item.label}
        </p>
        <TextReveal as="h3" className={styles.title}>
          {item.title}
        </TextReveal>
        <p className={styles.text}>{item.text}</p>
        <ul className={styles.points}>
          {item.points.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
        <Button href={item.href} variant="link" tone="light">
          Learn more
        </Button>
      </Reveal>
      <div className={styles.media}>
        <span className={styles.bigIndex} aria-hidden="true">
          0{index + 1}
        </span>
        <motion.img
          className={styles.icon}
          src={item.icon}
          alt=""
          loading="lazy"
          initial={reduce ? false : { scale: 0.86, rotate: -6 }}
          whileInView={{ scale: 1, rotate: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9, ease: EASE }}
        />
      </div>
    </article>
  );
};

const Capabilities = () => (
  <Section tone="light" id="capabilities" labelledBy="capabilities-title">
    <SectionIntro
      id="capabilities-title"
      eyebrow="Capabilities"
      title="The infrastructure behind every trial."
      lead="KUR handles the work that keeps research off a practice's plate and consistent across every site."
    />
    <div className={styles.list}>
      {capabilities.map((c, i) => (
        <Block key={c.id} item={c} index={i} />
      ))}
    </div>
  </Section>
);

export default Capabilities;
